import { render } from "./J05ChatScreenPanelMessage.vue?vue&type=template&id=1d0a82a2&scoped=true&ts=true"
import script from "./J05ChatScreenPanelMessage.vue?vue&type=script&lang=ts"
export * from "./J05ChatScreenPanelMessage.vue?vue&type=script&lang=ts"

import "./J05ChatScreenPanelMessage.vue?vue&type=style&index=0&id=1d0a82a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0a82a2"]])

export default __exports__